import {useMemo} from 'react';
import {StaticLandingEventMoreFetcher} from '../../../../common/fetchers/StaticLandingEventMoreFetcher';
import {t} from '../../../../common/getTranslations';
import {isGreaterThanZero} from '../../../../common/isGreaterThanZero';
import {LogTabType} from '../../../../common/LogTabType.enum';
import {TabPositionSticky} from '../../../../common/presentational/TabPositionSticky';
import {requestContext} from '../../../../common/requestContext';
import {MainTab} from '../../../../design-system/organisms/MainTab/MainTab';
import {MainTabItemType} from '../../../../design-system/organisms/MainTab/MainTabItemType.interface';
import {NoItem} from '../../../../design-system/organisms/NoItem/NoItem';
import {StaticLandingEventSection} from '../../../../graphql/generated/types';
import {putTiaraObjectProps} from '../../../../logging/putTiaraObjectProps';
import {CommonSectionProps} from '../../type';

export function StaticLandingEvent({section, children}: CommonSectionProps) {
  const {isMobile, isWebView} = requestContext.requestInfo.display;

  const staticLandingEventSection = section as Omit<
    StaticLandingEventSection,
    'groups'
  >;
  const {
    param: {categoryUid},
    categoryTabList,
    totalCount,
  } = staticLandingEventSection;

  const categoryList: MainTabItemType[] = useMemo(
    () =>
      categoryTabList.map(({param, name}) => ({
        id: Number(param),
        text: name,
        href: `/landing/event/${param}`,
      })),
    [categoryTabList]
  );

  const currentCategoryName = useMemo(
    () =>
      categoryTabList.find(
        categoryInfo => categoryInfo.param === String(categoryUid)
      )?.name,
    [categoryTabList, categoryUid]
  );

  return (
    <div
      className="flex flex-col w-full grow"
      {...putTiaraObjectProps({
        customProps: {
          page_category_filter: currentCategoryName,
        },
        click: {
          layer1: '섹션',
        },
      })}
    >
      <TabPositionSticky
        depth={1}
        disabled={!isMobile}
        isMobile={isMobile}
        isWebView={isWebView}
      >
        <MainTab
          isMobile={isMobile}
          title={t('landing_event')}
          tabItems={categoryList}
          currentTabItemId={categoryUid}
          className={!isMobile ? 'px-15pxr' : undefined}
          showBorder={true}
          logTabType={LogTabType.Category}
        />
      </TabPositionSticky>
      {isGreaterThanZero(totalCount) && (
        <StaticLandingEventMoreFetcher section={staticLandingEventSection}>
          <div className="flex flex-col grow py-15pxr">{children}</div>
        </StaticLandingEventMoreFetcher>
      )}
      {!isGreaterThanZero(totalCount) && (
        <NoItem isMobile={isMobile}>{t('landing_event_empty')}</NoItem>
      )}
    </div>
  );
}
